import moment from 'moment';

const ISO_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,9})?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;

export function formatUiDateTime(value) {
  if (typeof value !== 'string' || !ISO_DATE_TIME_PATTERN.test(value)) {
    return value;
  }

  const parsed = moment(value, moment.ISO_8601, true);
  if (!parsed.isValid()) {
    return value;
  }

  const hasMeaningfulTime = value.includes('T') && (
    parsed.hour() !== 0
    || parsed.minute() !== 0
    || parsed.second() !== 0
    || parsed.millisecond() !== 0
  );

  return parsed.format(hasMeaningfulTime ? 'D MMM YYYY, HH:mm' : 'D MMM YYYY');
}
